var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16927 15.9147C4.16927 16.375 4.54237 16.748 5.0026 16.748C5.46284 16.748 5.83594 16.375 5.83594 15.9147L5.83594 5.84322L6.91335 6.92064C7.23879 7.24607 7.76642 7.24607 8.09186 6.92064C8.4173 6.5952 8.4173 6.06756 8.09186 5.74212L6.18112 3.83138C5.53024 3.18051 4.47497 3.18051 3.82409 3.83138L1.91335 5.74212C1.58791 6.06756 1.58791 6.5952 1.91335 6.92064C2.23879 7.24607 2.76642 7.24607 3.09186 6.92064L4.16927 5.84322L4.16927 15.9147Z",
    fill: "#1A1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.1764C10 14.6367 10.3731 15.0098 10.8333 15.0098H17.5C17.9602 15.0098 18.3333 14.6367 18.3333 14.1764C18.3333 13.7162 17.9602 13.3431 17.5 13.3431H10.8333C10.3731 13.3431 10 13.7162 10 14.1764Z",
    fill: "#1A1D1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0091C10 9.54888 10.3731 9.17578 10.8333 9.17578H15C15.4602 9.17578 15.8333 9.54888 15.8333 10.0091C15.8333 10.4694 15.4602 10.8424 15 10.8424H10.8333C10.3731 10.8424 10 10.4694 10 10.0091Z",
    fill: "#1A1D1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.8431C10 5.38286 10.3731 5.00977 10.8333 5.00977H12.5C12.9602 5.00977 13.3333 5.38286 13.3333 5.8431C13.3333 6.30334 12.9602 6.67643 12.5 6.67643H10.8333C10.3731 6.67643 10 6.30334 10 5.8431Z",
    fill: "#1A1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/sort_ascending.87d9786059c376097c8800998056ac23.svg";
export { ForwardRef as ReactComponent };